<template>
  <div class="payment-container">
    <div class="payment-card">
      <h1 class="payment-title">预约支付</h1>
      
      <div class="input-group">
        <label>金额（元）</label>
        <input 
    type="number" 
    v-model="amount"
    @input="formatDecimal"
    step="0.01"
    min="0"
    placeholder="0.00"
  >
      </div>

    

      <button @click="handlePayment" class="payment-button">
        立即支付
      </button>
      
   
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      amount: null,
      email: '',
      orderUrl: ''
    };
  },
  methods: {
    generateOrderId() {
      const now = new Date();
      return now.getTime().toString();
    },
    formatDecimal() {
      // 即时格式化显示
      if (this.amount) {
        // this.amount = parseFloat(this.amount).toFixed(2)
      }
    },
    validateInput() {
      // 新增金额格式验证
      if (!/^\d+(\.\d{1,2})?$/.test(this.amount)) {
        alert('金额格式不正确，请输入数字且最多保留两位小数');
        return false;
      }
      return true;
    },
    async handlePayment() {
      if (!this.validateInput()) return;
      
   

      try {
          // 格式转换核心代码
          const formattedAmount = this.amount.toFixed(2).toString();
          // alert(formattedAmount);
        const orderId = this.generateOrderId();
        // alert(orderId);
        const response = await axios.post('/getSign', {
          totalPrice: formattedAmount,
          email: "wlt@mail.com",
          newProductId: orderId
        });
        // alert(JSON.stringify(response));
        if (response.data?.data?.order_url) {
          // alert(response.data.data.order_url);
          window.location.href = response.data.data.order_url;
          
        } else {
          alert('获取支付链接失败，请稍后重试');
        }
      } catch (error) {
        console.error('支付请求失败:', error);
        alert('支付请求发送失败', error);
        // alert(error, error);
      }
    },
    
  }
};
</script>

<style scoped>
.payment-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.payment-card {
  background: white;
  padding: 2.5rem;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.payment-title {
  color: #2c3e50;
  margin-bottom: 2rem;
  font-size: 1.8rem;
  font-weight: 600;
}

.input-group {
  margin-bottom: 1.5rem;
  text-align: left;
}

.input-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #4a5568;
  font-weight: 500;
}

input {
  width: 100%;
  padding: 0.8rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.payment-button {
  width: 100%;
  padding: 1rem;
  background: #48bb78;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s ease;
}

.payment-button:hover {
  background: #38a169;
}

.tip-text {
  color: #718096;
  margin-top: 1.5rem;
  font-size: 0.9rem;
}
</style>